/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
/**
 * Internal dependencies
 */

var metadata = {
  name: "core/site-title",
  category: "layout"
};
import icon from './icon';
import edit from './edit';
var name = metadata.name;
export { metadata, name };
export var settings = {
  title: __('Site Title'),
  icon: icon,
  edit: edit
};